import React, { useCallback, useEffect, useState } from "react";
import { StatisticsTrackItem, useMusicApi } from "../../../api/useMusicApi";
import { useLoading } from "../../../hooks/use-loading";
import {
  StatisticsTopsFilters,
  StatisticsTopsFiltersParams,
} from "./StatisticsTopsFilters";
import { Card } from "../../../components/Card/Card";
import { CardBody } from "../../../components/Card/CardBody";
import { CardContentPreloader } from "../../../components/Card/CardContentPreloader";
import { Table } from "../../../components/Table/Table";
import { statisticsTopsColumnsDefinition } from "./StatisticsTopsColumnsDefinition";
import { StatisticPeriod, StatisticPlatform } from "../StatisticsPage";
import { usePageHelper } from "../../../hooks/use-page-helper";

type Props = {
  onChange: (totalCount: number | string, currentCount: number) => void;
};
export const StatisticsTops: React.FC<Props> = ({ onChange }) => {
  const { t } = usePageHelper("tops");
  const api = useMusicApi();
  const [items, setItems] = useState<StatisticsTrackItem[]>([]);
  const { startLoading, stopLoading, loadings } = useLoading({
    tops: true,
  });

  useEffect(() => {
    if (items.length > 0) {
      onChange(100, 100);
    }
  }, [items]);

  useEffect(() => {
    fetchData({
      period: StatisticPeriod.LAST_WEEK,
      platform: StatisticPlatform.VK_BOOM,
    }).then();
  }, []);

  const fetchData = useCallback(
    async (params?: StatisticsTopsFiltersParams) => {
      try {
        startLoading("tops");
        const res = await api.getStatisticsTops(
          params?.platform as any,
          params?.period as any,
        );
        setItems(res.results);
      } catch (e) {
      } finally {
        stopLoading("tops");
      }
    },
    [],
  );

  return (
    <>
      <div className={"flex justify-between items-center flex-wrap mb-3 gap-2"}>
        <StatisticsTopsFilters onApply={fetchData} />
      </div>
      <Card>
        <CardBody>
          <>
            {loadings.tops ? (
              <CardContentPreloader />
            ) : (
              <Table
                data={items}
                columnsDefinition={statisticsTopsColumnsDefinition(t, true)}
              />
            )}
          </>
        </CardBody>
      </Card>
    </>
  );
};
